export enum ReportType {
  EPS_REPORT_TYPE_ON_DEMAND_SCAN = 67840,
  EPS_REPORT_TYPE_ON_DEMAND_PATCH_SCAN = 80128,
  EPS_REPORT_TYPE_ON_DEMAND_PATCH_INSTALL = 81920,
  EPS_REPORT_TYPE_ON_DEMAND_PATCH_UNINSTALL = 82944,
  EPS_REPORT_TYPE_ENDPOINT_INSTALLATION = 68096,
  EPS_REPORT_TYPE_IOC_SCAN = 18176,

  SVE_REPORT_TYPE_ON_DEMAND_SCAN = 133376,
  SVE_REPORT_TYPE_ON_DEMAND_PATCH_SCAN = 145664,
  SVE_REPORT_TYPE_ON_DEMAND_PATCH_INSTALL = 147456,
  SVE_REPORT_TYPE_ON_DEMAND_PATCH_UNINSTALL = 148480,
  SVE_REPORT_TYPE_ENDPOINT_INSTALLATION = 133632,
  SVE_REPORT_TYPE_IOC_SCAN = 18176,

  MDM_REPORT_TYPE_ON_DEMAND_SCAN = 264448,
}

export enum ReportScheduleType {
  SCHEDULE_TYPE_DASHBOARD = 0,
  SCHEDULE_TYPE_NOW = 1,
  SCHEDULE_TYPE_RECURRENT = 2,
  SCHEDULE_TYPE_TASK = 3,
}

export enum ReportRecurrenceType {
  RECURRENCE_TYPE_DASHBOARD = 0,
  RECURRENCE_TYPE_NOW = 1,
  RECURRENCE_TYPE_DAILY = 2,
  RECURRENCE_TYPE_WEEKLY = 3,
  RECURRENCE_TYPE_MONTHLY = 4,
  RECURRENCE_TYPE_TASK = 5,
  RECURRENCE_TYPE_HOURLY = 6,
  RECURRENCE_TYPE_YEARLY = 7,
}
